export default __webpack_public_path__ + "static/media/eye (2).bd4ce3d3.svg";